<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
    import router from "./router";
    export default {
        name: "App",
        data() {
            return {
                recordAuditStatus: ''
            };
        },
        created() {
            let that = this;
            var routerString;
            if (window.currentRouter && window.currentRouter.indexOf("?") != -1) {
                routerString = window.currentRouter.split("?")[0];
            }
            if(window.location.href.indexOf("scan")<0){
                this.$http.get("front/session").then(async response => {
                    var data = response.data.data;
                    if (response.data.status == 1) {
                        let studioType = await this.$http.get("front/studio/completeinfo").then((res) => {
                            if (res.data.status === 1) {
                                this.recordAuditStatus = res.data.recordAuditStatus
                            }
                            if (res.data.status === 1) {
                                if(res.data.data[0].studioType == 15) {
                                return 15
                            }
                            }
                        })
                        if(studioType && studioType == 15) {
                            data.studioType = 15
                        }
                        data = {...data, recordAuditStatus : this.recordAuditStatus}
                        var userinfo = $.extend({},this.$store.state.userinfo,data);
                        // if (userinfo.recordAuditStatus === 'eliminate') {
                        //     this.$router.push('/personal')
                        // }
                        if (data.typeId == "2" || data.typeId == "4" || data.typeId == "8") {
                            userinfo.auditStatus = "";
                        }
                        this.$store.commit('set', {
                            token: response.data.token
                        })
                        this.$store.commit('set', {
                            userinfo
                        })
                        localStorage.setItem('userinfo', JSON.stringify(userinfo))
                        if (response.data.status != 2) {
                            // if (data.typeId == 1) {
                            //     this.$http.get("front/studio/completeinfo").then((res) => {
                            //         if (res.data.status == 1) {
                            //             userinfo.auditStatus = res.data.data[0].auditStatus;
                            //             userinfo.completeinfo = res.data.completeinfo;
                            //             userinfo.studioName = res.data.data[0].studioName;
                            //         }
                            //         this.$store.commit('set', {
                            //             userinfo
                            //         })
                            //         localStorage.setItem('userinfo', JSON.stringify(userinfo))
                            //     })
                            // } else {
                            //     this.$store.commit('set', {
                            //         userinfo
                            //     })
                            //     localStorage.setItem('userinfo', JSON.stringify(userinfo))
                            // }
                            window.routeReady = true;
                            router.replace(window.currentRouter);
                        }
                    }
                });
            }
            // this.$http.get("front/sso/login").then(response => {
            //     localStorage.setItem('ssoUrl', response.request.responseURL)
            // })
        },
        mounted() {
            // 检测浏览器路由改变页面不刷新问题,hash模式的工作原理是hashchange事件
            window.addEventListener('hashchange', () => {
                let currentPath = window.location.hash.slice(1)
                if (this.$route.path !== currentPath) {
                    this.$router.push(currentPath)
                }
            }, false)
        },
    };
</script>


// WEBPACK FOOTER //
// app.vue?0dfa7870